import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { IJobOffer } from '../../../assets/types/dtoTypes';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  standalone: true,
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  imports: [FormsModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent implements OnChanges {
  @Input() offers: IJobOffer[] = [];

  @Output() searchResult = new EventEmitter<IJobOffer[]>();

  searchTerm = '';
  private search$ = new Subject<string>();

  constructor() {
    this.search$.pipe(
      debounceTime(200),
      distinctUntilChanged()
    ).subscribe(term => this.emitFiltered(term));
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Re-apply filter if offers change
    if (changes['offers']) {
      this.emitFiltered(this.searchTerm);
    }
  }

  onSearchTermChange(value: string) {
    this.searchTerm = value ?? '';
    this.search$.next(this.searchTerm);
  }

  emitFiltered(term: string) {
    const t = (term || '').trim().toLowerCase();
    if (!t) {
      this.searchResult.emit(this.offers.slice());
      return;
    }

    const filtered = this.offers.filter(o => {
      const company = (o.companyName ?? '').toLowerCase();
      const title = (o.title ?? o.title ?? '').toLowerCase();
      const location = (o.location ?? '').toLowerCase();
      const desc = (o.description ?? '').toLowerCase();
      return company.includes(t) || title.includes(t) || location.includes(t) || desc.includes(t);
    });

    this.searchResult.emit(filtered);
  }
}
